export default __webpack_public_path__ + "static/media/sch-over3.4a6cde3a.svg";